var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styles from './styles';
var DEFAULT_BTN_TEXT = 'Copy to clipboard';
var COPIED_BTN_TEXT = 'Copied!';
var CopyToClipboard = /** @class */ (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isActive: false,
            btnLabel: DEFAULT_BTN_TEXT
        };
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.copyToClipboard = _this.copyToClipboard.bind(_this);
        return _this;
    }
    CopyToClipboard.prototype.handleMouseEnter = function () {
        var onMouseEnter = this.props.onMouseEnter;
        this.setState({ isActive: true });
        if (onMouseEnter)
            onMouseEnter();
    };
    CopyToClipboard.prototype.handleMouseLeave = function () {
        var onMouseLeave = this.props.onMouseLeave;
        this.setState({ isActive: false });
        if (onMouseLeave)
            onMouseLeave();
    };
    CopyToClipboard.prototype.copyToClipboard = function () {
        var _this = this;
        var _a = this.props, copyText = _a.copyText, children = _a.children, onCopy = _a.onCopy, onCopyBtnLabelDuration = _a.onCopyBtnLabelDuration;
        var el = document.createElement('textarea');
        el.value = copyText || children.toString();
        var copiedText = copyText || children.toString();
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.setState({ btnLabel: COPIED_BTN_TEXT });
        if (onCopy)
            onCopy(copiedText);
        setTimeout(function () {
            _this.setState({ btnLabel: DEFAULT_BTN_TEXT });
        }, onCopyBtnLabelDuration);
    };
    CopyToClipboard.prototype.render = function () {
        var _a = this.state, isActive = _a.isActive, btnLabel = _a.btnLabel;
        var _b = this.props, activeContainerStyle = _b.activeContainerStyle, activeTextStyle = _b.activeTextStyle, btnStyle = _b.btnStyle, children = _b.children;
        var _c = this.props, containerStyle = _c.containerStyle, textStyle = _c.textStyle;
        containerStyle = __assign(__assign({}, styles.containerStyle), containerStyle);
        textStyle = __assign(__assign({}, styles.textStyle), textStyle);
        var copyBtnStyle = styles.copyBtnStyle;
        if (isActive) {
            containerStyle = __assign(__assign(__assign({}, containerStyle), styles.activeContainerStyle), activeContainerStyle);
            copyBtnStyle = __assign(__assign(__assign({}, copyBtnStyle), styles.activeCopyBtnStyle), btnStyle);
            textStyle = __assign(__assign({}, textStyle), activeTextStyle);
        }
        return (React.createElement("div", { style: __assign({}, containerStyle), onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
            React.createElement("div", { style: __assign({}, textStyle) }, children),
            React.createElement("button", { type: "button", style: copyBtnStyle, onClick: this.copyToClipboard }, btnLabel || DEFAULT_BTN_TEXT)));
    };
    return CopyToClipboard;
}(React.Component));
export default CopyToClipboard;
